module.exports = __webpack_public_path__ + "static/img/product_images_07_h5_zh.77667f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_07_h5_zh.png
// module id = 2NUl
// module chunks = 34